import { c as _c } from "react/compiler-runtime";
import React, { useRef, useEffect } from "react";
import { useHits, Pagination } from "react-instantsearch";
import SearchHit from "../../SectionBlogDigest/Search/SearchHit";
import { useSearchLabels } from "./SearchLabelsContext";
const connectHits = (Component: any) => {
  const Hits = props => {
    const $ = _c(3);
    const data = useHits();
    let t0;
    if ($[0] !== data || $[1] !== props) {
      t0 = <Component {...props} {...data} />;
      $[0] = data;
      $[1] = props;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  };
  return Hits;
};
export const Hits = t0 => {
  const $ = _c(19);
  const {
    hits,
    isSecondIndex,
    locale,
    totalHits,
    searchWrapperRef
  } = t0;
  const labels = useSearchLabels();
  const paginationWrapperRef = useRef(null);
  let t1;
  if ($[0] !== searchWrapperRef) {
    t1 = e => {
      if (window && e?.target?.classList?.contains("ais-Pagination-link") && e?.target?.nodeName === "A") {
        searchWrapperRef?.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    };
    $[0] = searchWrapperRef;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const wrapperClickHandler = t1;
  let t2;
  if ($[2] !== wrapperClickHandler) {
    t2 = () => {
      const currentRef = paginationWrapperRef.current;
      if (currentRef) {
        currentRef.addEventListener("click", wrapperClickHandler);
      }
      return () => {
        if (currentRef) {
          currentRef.removeEventListener("click", wrapperClickHandler);
        }
      };
    };
    $[2] = wrapperClickHandler;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== searchWrapperRef || $[5] !== wrapperClickHandler) {
    t3 = [searchWrapperRef, wrapperClickHandler];
    $[4] = searchWrapperRef;
    $[5] = wrapperClickHandler;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  const t4 = `nav-search__hits ${isSecondIndex ? "nav-search__hits--second-index" : ""}`;
  let t5;
  if ($[7] !== hits || $[8] !== locale) {
    t5 = hits?.map(hit => <li key={hit.objectID} className="nav-search__hits--item"><SearchHit hit={hit} locale={locale} /></li>);
    $[7] = hits;
    $[8] = locale;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <ul className="nav-search__hits--list">{t5}</ul>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== labels || $[13] !== totalHits) {
    t7 = totalHits > 5 && <div ref={paginationWrapperRef}><Pagination showFirst={false} showLast={false} padding={2} translations={{
        previousPageItemAriaLabel: labels.previous,
        nextPageItemAriaLabel: labels.next
      }} /></div>;
    $[12] = labels;
    $[13] = totalHits;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <><div className={t4}>{t6}{t7}</div></>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
const CustomHits = connectHits(Hits);
export default CustomHits;